export const STORE_FEATURE_EB_MULTI_CART = 'ebCart'
